export const emailRegex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phoneRegex = /^\d{10}$/;

export const required = value => !!value || "Campo requerido";
export const email = (value) => emailRegex.test(value) || "Ingrese un correo válido";
export const maxSize = value => !value || value.size < 2000000 || "Logo no puede pesar más de 2MB";
export const minOne = (v) => v >= 1 || "Min. 1";
export const minAlmostZero = (v) => v >= 0.1 || "Min. 0.1";